import { AddLink, DeleteButton, EditLink } from "app/components/buttons";
import { Column } from "app/components/column";
import { Container } from "app/components/container";
import { DFlexResponsive } from "app/components/d-flex-responsive";
import { Row } from "app/components/row";
import { Table } from "app/components/table";
import { useEmpresa } from "app/contexts";

export function ExportacionesTable() {
  const { empresa, deleteExportacion } = useEmpresa();

  return (
    <Container>
      <Row>
        <Column>
          <DFlexResponsive justifyContent="between">
            <h5>
              <strong>Exportaciones (opcional)</strong>
            </h5>

            <AddLink to="exportaciones/add" title="Agregar exportación" />
          </DFlexResponsive>
        </Column>

        <Column>
          {!!empresa.exportaciones.length ? (
            <Table titles={["#", "Tipo", "Exportación", "Opciones"]}>
              {empresa.exportaciones.map((exportacion, i) => (
                <tr key={i}>
                  <td className="text-center">{i + 1}</td>

                  <td className="text-center">
                    {exportacion.exportacion_principal
                      ? "Principal"
                      : "Secundaria"}
                  </td>

                  <td>{exportacion.exportacion_detalles}</td>

                  <td>
                    <DFlexResponsive>
                      <EditLink to={`exportaciones/${i}/edit`} />

                      <DeleteButton
                        size="sm"
                        onClick={() => deleteExportacion(i)}
                      />
                    </DFlexResponsive>
                  </td>
                </tr>
              ))}
            </Table>
          ) : (
            <p className="lead text-center">
              Si exporta, por favor, agregue los productos que exporta.
            </p>
          )}
        </Column>
      </Row>
    </Container>
  );
}
